import Vue from 'vue'
import { Component, Prop, PropSync } from 'vue-property-decorator'

@Component({})
export default class ModalLayout extends Vue {
  @PropSync('item', { type: Boolean }) isModalOpen!: boolean;
  @Prop({ type: String }) text!: string;

  closeModal() {
    this.isModalOpen = false;
  }
}